<template>
  <div class="change-img-box">
    <el-radio-group v-model="radio" class="dig-radio" @change="radioChange">
      <el-radio :label="4">海报1</el-radio>
      <el-radio :label="5">海报2</el-radio>
      <el-radio :label="7">海报3</el-radio>
      <el-radio :label="8">海报4</el-radio>
      <el-radio :label="9">海报5</el-radio>
      <el-radio :label="2">海报6</el-radio>
      <el-radio :label="3">海报7</el-radio>
      <el-radio :label="10">海报8</el-radio>
      <el-radio :label="11">海报9</el-radio>
      <el-radio :label="12">海报10</el-radio>
      <el-radio :label="13">海报11</el-radio>
      <el-radio :label="14">海报12</el-radio>

    </el-radio-group>
    <div class="ref-img-div" v-loading="imgLoadMod">
      <img :src="dataImgUrl" alt="" width="100%">
    </div>
    <div class="imageWrapper" ref="imageWrapper">
      <slot>
        <component :is="componentView" :info="info" :code="code" @codeImgLoad="imgLoad"></component>
      </slot>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import Card1 from '@/components/sharePoster/Card1'
import Card2 from '@/components/sharePoster/Card2'
import Card3 from '@/components/sharePoster/Card3'
import Card4 from '@/components/sharePoster/Card4'
import Card5 from '@/components/sharePoster/Card5'
import Card6 from '@/components/sharePoster/Card6'
import Card7 from '@/components/sharePoster/Card7'
import Card8 from '@/components/sharePoster/Card8'
import Card9 from '@/components/sharePoster/Card9'
import Card10 from '@/components/sharePoster/Card10'
import Card11 from '@/components/sharePoster/Card11'
import Card12 from '@/components/sharePoster/Card12'
import Card13 from '@/components/sharePoster/Card13'
import Card14 from '@/components/sharePoster/Card14'

export default {
  props: ['id', 'info'],
  data () {
    return {
      imgLoadMod: false,
      code: '',
      radio: 4,
      dataImgUrl: '',
      componentView: 'Card4'
    }
  },
  components: {
    Card1,
    Card2,
    Card3,
    Card4,
    Card5,
    Card6,
    Card7,
    Card8,
    Card9,
    Card10,
    Card11,
    Card12,
    Card13,
    Card14
  },
  mounted () {
    this.imgQrLoad()
  },
  methods: {
    imgQrLoad () {
      this.imgLoadMod = true
      this.$axios.get('/recruitment/position/getQrcode/'+ this.id,{
      }).then(res => {
        this.code=res.data.img
      })
    },
    getImgToCode () {
      html2canvas(this.$refs.imageWrapper, {
        backgroundColor: null,
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true,//允许跨域图片
      }).then(res => {
        console.log(res)
        let dataUrl = res.toDataURL('image/jpeg', 1)
        this.dataImgUrl = dataUrl
      }).finally(() => {
        this.imgLoadMod = false
      })
    },
    imgLoad () {
      this.getImgToCode()
    },
    radioChange (val) {
      this.imgLoadMod = true
      this.componentView = 'Card' + val
    }
  }
}
</script>

<style lang="scss">
@import '$styles/global.scss';

.change-img-box{
  width: 100%;
  margin-top: 20px;
  @include flex-box(center, flex-start);

  .dig-radio{
    width: 100%;
    @include flex-box(flex-start);
    margin-bottom: 20px;
    .el-radio{
      margin-bottom: 10px;
      color: #888D96;
    }
  }

  .ref-img-div{
    width: 205px;
  }

  .imageWrapper{
    //  display: none;
    position: fixed;
    top: 0;
    left: -700px;
    width: 600px;
    overflow: hidden;

    // position:absolute;
    // top: 50px;
    // left: -210px;
    // right: 0;
    // // width: 375px;
    // height: 1300px;
    // overflow:auto;
    // bottom: 50px;
  }
}
</style>
